"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameSession = void 0;
const types_1 = require("../types");
const Player_1 = require("./Player");
class GameSession {
    constructor(data) {
        this.id = data.id;
        this.adventureId = data.adventureId;
        this.players = data.players.map((p) => new Player_1.Player(p));
        this.locationInventories = new Map(data.locationInventories || new Map());
        this.status = data.status;
        this.createdAt = data.createdAt;
        this.updatedAt = data.updatedAt;
        this.createdByUserId = data.createdByUserId;
        this.isGuest = data.isGuest;
    }
    getPlayer(playerId) {
        return this.players.find(p => p.id === playerId);
    }
    getPlayerByCharacter(characterName) {
        return this.players.find(p => p.characterName === characterName);
    }
    getPlayerByPlayerName(playerName) {
        return this.players.find(p => p.playerName === playerName);
    }
    addPlayer(player) {
        if (!this.getPlayer(player.id)) {
            this.players.push(player);
            this.updateTimestamp();
        }
    }
    createPlayerFromDefinition(playerId, playerName, characterName, startingScene) {
        const playerData = {
            id: playerId,
            playerName,
            characterName,
            currentCharacter: characterName,
            userId: this.createdByUserId, // Use session creator's userId as default
            inventory: [],
            stats: [],
            sceneHistory: [startingScene], // Add starting scene to history
            currentScene: startingScene
        };
        const player = new Player_1.Player(playerData);
        this.addPlayer(player);
        return player;
    }
    removePlayer(playerId) {
        const index = this.players.findIndex(p => p.id === playerId);
        if (index > -1) {
            this.players.splice(index, 1);
            this.updateTimestamp();
        }
    }
    updatePlayer(player) {
        const index = this.players.findIndex(p => p.id === player.id);
        if (index > -1) {
            this.players[index] = player;
            this.updateTimestamp();
        }
    }
    isActive() {
        return this.status === types_1.GameStatus.ACTIVE;
    }
    isCompleted() {
        return this.status === types_1.GameStatus.COMPLETED;
    }
    setStatus(status) {
        this.status = status;
        this.updateTimestamp();
    }
    getLocationInventory(locationTag) {
        return this.locationInventories.get(locationTag) || [];
    }
    setLocationInventory(locationTag, items) {
        this.locationInventories.set(locationTag, [...items]);
        this.updateTimestamp();
    }
    initializeLocationInventory(locationTag, startingInventory) {
        if (!this.locationInventories.has(locationTag)) {
            this.locationInventories.set(locationTag, [...startingInventory]);
            this.updateTimestamp();
        }
    }
    hasLocationItem(locationTag, itemTag) {
        const inventory = this.locationInventories.get(locationTag);
        return inventory ? inventory.includes(itemTag) : false;
    }
    addLocationItem(locationTag, itemTag) {
        const inventory = this.locationInventories.get(locationTag) || [];
        if (!inventory.includes(itemTag)) {
            inventory.push(itemTag);
            this.locationInventories.set(locationTag, inventory);
            this.updateTimestamp();
        }
    }
    removeLocationItem(locationTag, itemTag) {
        const inventory = this.locationInventories.get(locationTag);
        if (inventory) {
            const index = inventory.indexOf(itemTag);
            if (index > -1) {
                inventory.splice(index, 1);
                this.updateTimestamp();
            }
        }
    }
    updateTimestamp() {
        this.updatedAt = new Date();
    }
    toJSON() {
        return {
            id: this.id,
            adventureId: this.adventureId,
            players: this.players.map(p => p.toJSON()),
            locationInventories: this.locationInventories,
            status: this.status,
            createdAt: this.createdAt,
            updatedAt: this.updatedAt,
            createdByUserId: this.createdByUserId,
            isGuest: this.isGuest
        };
    }
}
exports.GameSession = GameSession;
//# sourceMappingURL=GameSession.js.map